export default "__VITE_ASSET__DeRo0tZr__"